import { query } from 'qs'
import fetch from 'fetch'
import auth from 'auth'
import _ from 'lodash'
import defaultConfig from './default'
import paymentTypes from 'payment-types'
import orderService from 'service/order'
import cookie from 'cookie'

const FENQILE_CLIENT_ID = 'piaoniu'

module.exports = _.merge({}, defaultConfig, {
  name: '分期乐',
  premiumMessage: '热门票品售价高于票面价格，如确定购买，请知悉',
  noLoginPhonePlaceholder: '请填写与分期乐一致的手机号，以免影响下单',
  stripBrand: true,
  match () {
    const matched = navigator.userAgent.match('fenqile') || query.channel === 'fenqile' || cookie.get('channel') === 'fenqile'
    if (process.browser) {
     window.pnlogger && window.pnlogger.sendPageLog && window.pnlogger.sendPageLog('is in fenqile:' + matched)
    }
    return matched
  },
  auth (redirect) {
    if (!query.code) {
      redirect = auth.redirectURL(redirect || location.href, 2)
      const toJump = `http://open.api.fenqile.com/auth/connect.html?client_id=${FENQILE_CLIENT_ID}&redirect_uri=${encodeURIComponent(redirect)}`
      location.href = toJump
    }
  },
  login (redirect) {
    if (cookie.get('tper')) {
      return Promise.resolve()
    }
    if (query.code) {
      console.log('tp login by code ' + query.code)
      return fetch({
        method: 'post',
        url: `/v1/fenqile/tpLogin?code=${query.code}`
      })
    } else {
      console.log('auth redirect')
      this.auth(redirect)
    }
  },
  pay (subjectId, subjectType, paymentAmount) {
    return orderService.unifiedPay({
      subjectId,
      subjectType,
      paymentType: paymentTypes.fenqile,
      paymentAmount: paymentAmount
    }).then(({ paymentParams }) => {
      const { third_order } = paymentParams
      window.location.href = third_order
    })
  }
})



// WEBPACK FOOTER //
// ./src/mods/channels/fenqile.js